import React from "react";
import { Row } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";

function LogoComponent() {
  return (
    <Row
      className={css(styles.container)}
      horizontal="center"
      vertical="center"
    >
      <img
        src={require("../../assets/ic_paboi2.png")}
        className={css(styles.logo)}
        alt="logo-paboi"
      />
      <span className={css(styles.title)}>
        INDONESIAN ORTHOPEDIC ASSOCIATION
      </span>
    </Row>
  );
}

const styles = StyleSheet.create({
  container: {
    marginLeft: 32,
    marginRight: 32,
  },
  title: {
    fontWeight: "bold",
    fontSize: 10,
    lineHeight: "16px",
    color: "#FFFFFF",
    marginLeft: 10,
  },
  logo: {
    height: 60,
    width: 60,
  },
});

export default LogoComponent;
